'use client'

import type { ReactNode } from 'react'
import { cx } from './utils/cx'

export function Chip({
  on,
  count,
  onClick,
  children
}: {
  on?: boolean
  count?: number | string
  onClick?: () => void
  children?: ReactNode
}) {
  return (
    <button type="button" className={cx('st-chip', on && 'on')} onClick={onClick}>
      {children}
      {count != null && <span className="count">{count}</span>}
    </button>
  )
}
